import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {
  Button,
  Card,
  CardContent,
  Typography,
  Grid,
  SnackbarContent,
} from '@material-ui/core'
import classNames from 'classnames'
import {Formik} from 'formik'
import * as yup from 'yup'
import {FuseAnimate} from '@fuse'
import {Mutation} from 'react-apollo'
import qs from 'qs'
import {toast} from 'react-toastify'

import {
  FormikTextField,
  GridItem,
} from '../project/ecommerce/storeSettings/components/common'
import {RESET_PASSWORD} from '../../../graphql/mutation'

const styles = () => ({
  root: {
    background:
      "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
    backgroundSize: 'cover',
  },
  card: {
    width: '100%',
    maxWidth: 384,
  },
})

const validationSchema = yup.object({
  newPassword: yup
    .string()
    .min(6, 'Password must contain at least 6 characters')
    .required(),
  confirmNewPassword: yup
    .string()
    .min(6, 'Password must contain at least 6 characters')
    .oneOf([yup.ref('newPassword'), null], 'Confirm password doesn\'t match with new password')
    .required(),
})
class ResetPasswordPage extends Component {
  state = {
    done: false,
    token: '',
    email: '',
  }

  componentDidMount() {
    const {email, token} = qs.parse(this.props.location.search.replace('?', ''))
    if (!token || !email) {
      this.props.history.replace('/login')
    }
    this.setState({ token, email })
  }

  handleSubmitResetPassword = async (resetPassword, values) => {
    try {
      await resetPassword({
        variables: {
          email: this.state.email,
          token: this.state.token,
          password: values.newPassword,
        },
      })
      this.setState({ done: true })
    } catch (resetPasswordError) {
      resetPasswordError.graphQLErrors.forEach(
        ({message}) => {
          toast.error(message, {
            position:
              toast.POSITION.BOTTOM_RIGHT,
          })
        },
      )
    }
  }

  render() {
    const {classes} = this.props
    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32',
        )}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent className="flex flex-col items-center justify-center p-32">
                <img
                  className="w-128 m-32"
                  src="assets/images/logos/deeple_dark.png"
                  alt="logo"
                />

                <Typography variant="title" className="mt-16 mb-32">
                  Reset Password
                </Typography>
                {
                  this.state.done ? (
                    <Grid
                      container
                      justify="flex-start"
                      alignItems="center"
                      spacing={16}
                    >
                      <SnackbarContent
                        aria-describedby="client-snackbar"
                        message="Your password has been reset successfully, You can now use new password to sign-in."
                      />
                      <Button
                        color="secondary"
                        className="mt-16 mx-auto"
                        aria-label="Sign-In"
                        onClick={() => this.props.history.replace('/login')}
                      >
                        Sign-In
                      </Button>
                    </Grid>
                  ) : (
                    <Mutation
                      mutation={RESET_PASSWORD}
                    >
                      {resetPassword => {
                        return <Formik
                          enableReinitialize
                          initialValues={{
                            newPassword: '',
                            confirmNewPassword: '',
                          }}
                          onSubmit={values => {
                            this.handleSubmitResetPassword(resetPassword, values)
                          }}
                          validationSchema={validationSchema}
                          render={props => (
                            <form onSubmit={props.handleSubmit}>
                              <Grid container spacing={16}>
                                <Grid item xs={12}>
                                  <Grid
                                    container
                                    justify="flex-start"
                                    alignItems="center"
                                    spacing={16}
                                  >
                                    <GridItem item xs={12}>
                                      <FormikTextField
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        value={props.values.newPassword}
                                        errors={props.errors}
                                        touched={props.touched}
                                        type="password"
                                        name="newPassword"
                                        label="New Password"
                                        fullWidth
                                      />
                                    </GridItem>
                                    <GridItem item xs={12}>
                                      <FormikTextField
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        value={props.values.confirmNewPassword}
                                        errors={props.errors}
                                        touched={props.touched}
                                        type="password"
                                        name="confirmNewPassword"
                                        label="Confirm New Password"
                                        fullWidth
                                      />
                                    </GridItem>
                                    <Button
                                      variant="raised"
                                      type="submit"
                                      color="primary"
                                      className="w-224 mt-16 mx-auto"
                                      aria-label="Reset Password"
                                      disabled={props.isSubmitting}
                                    >
                                      Submit
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </form>
                          )}
                        />
                      }}
                    </Mutation>
                  )
                }
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    )
  }
}

export default withStyles(styles, {withTheme: true})(ResetPasswordPage)



// WEBPACK FOOTER //
// ./src/main/content/login/ResetPasswordPage.js